import { getAuth } from 'firebase/auth';
import app from '../firebase';

// 2nd Gen Firebase Functions URLs
const FUNCTIONS = {
  getUserProfile: 'https://getuserprofile-490883243221.us-central1.run.app',
  getUsers: 'https://getusers-490883243221.us-central1.run.app',
  updateUserRole: 'https://updateuserrole-490883243221.us-central1.run.app',
  updateUserProfile: 'https://updateuserprofile-490883243221.us-central1.run.app',
};

class ApiService {
  constructor() {
    this.auth = getAuth(app);
  }

  // Get authentication token
  async getAuthToken() {
    const user = this.auth.currentUser;
    if (!user) {
      throw new Error('No authenticated user');
    }
    return await user.getIdToken();
  }

  // Make authenticated API request
  async makeRequest(functionName, options = {}) {
    const token = await this.getAuthToken();
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    };

    const functionUrl = FUNCTIONS[functionName];
    if (!functionUrl) {
      throw new Error(`Unknown function: ${functionName}`);
    }

    const response = await fetch(functionUrl, {
      ...defaultOptions,
      ...options,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }

  // Get current user profile and permissions
  async getCurrentUserProfile() {
    return await this.makeRequest('getUserProfile');
  }

  // Get all users (admin only)
  async getAllUsers() {
    return await this.makeRequest('getUsers');
  }

  // Update user role (admin only)
  async updateUserRole(userId, newRole) {
    return await this.makeRequest('updateUserRole', {
      method: 'PUT',
      body: JSON.stringify({ userId, newRole }),
    });
  }

  // Update user profile
  async updateUserProfile(userId, updates) {
    return await this.makeRequest('updateUserProfile', {
      method: 'PUT',
      body: JSON.stringify({ userId, updates }),
    });
  }

  // Note: deactivateUser and deleteUser functions are not implemented yet
  // These would need to be added to the Firebase Functions backend
  async deactivateUser(userId) {
    throw new Error('deactivateUser function not implemented');
  }

  async deleteUser(userId) {
    throw new Error('deleteUser function not implemented');
  }
}

const apiService = new ApiService();
export default apiService; 